// src/pages/CMS/AdminLayout.jsx
import { Outlet } from "react-router-dom";
import LeftNav from "../CommonComponents/LeftNav";
import ChangePasswordModal from "../Admin/Login/ChangePasswordModal";
import { useAuth } from "../Admin/Login/AuthContext";
import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";
import "./cmsTheme.css";

const roleLabelMap = { SUPER:"최고 관리자", MANAGER:"중간 관리자", STAFF:"일반 관리자" };
const CMS_THEME_STORAGE_KEY = "wizmarket-cms-theme";

function getInitialDarkMode() {
  try {
    return window.localStorage.getItem(CMS_THEME_STORAGE_KEY) === "dark";
  } catch {
    return false;
  }
}

export default function AdminLayout() {
  const { me, reload } = useAuth();
  const [open, setOpen] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(getInitialDarkMode);

  useEffect(() => {
    if (me?.must_change_password) setOpen(true);
  }, [me]);

  useEffect(() => {
    document.body.classList.toggle("cms-dark-mode", isDarkMode);
    try {
      window.localStorage.setItem(
        CMS_THEME_STORAGE_KEY,
        isDarkMode ? "dark" : "light"
      );
    } catch {
      // 저장소를 사용할 수 없어도 현재 화면의 테마 전환은 유지한다.
    }

    return () => {
      document.body.classList.remove("cms-dark-mode");
    };
  }, [isDarkMode]);

  return (
    <div
      className={[
        "cms-theme min-h-screen bg-neutral-50",
        isDarkMode ? "cms-theme-dark" : "cms-theme-light",
      ].join(" ")}
    >
      <button
        type="button"
        className="cms-theme-toggle"
        onClick={() => setIsDarkMode((current) => !current)}
        aria-label={isDarkMode ? "라이트 모드로 변경" : "다크 모드로 변경"}
        aria-pressed={isDarkMode}
        title={isDarkMode ? "라이트 모드" : "다크 모드"}
      >
        {isDarkMode ? <Sun size={17} /> : <Moon size={17} />}
        <span>{isDarkMode ? "라이트 모드" : "다크 모드"}</span>
      </button>

      <div className="cms-layout mx-auto max-w-screen-2xl bg-white rounded-2xl shadow overflow-hidden">
        <div className="flex">
          <LeftNav
            userName={me?.username || "관리자"}
            userEmail={me?.email || ""}
            onChangePassword={() => setOpen(true)}
          />
          <div className="flex-1 min-w-0">
            <main className="">
              <Outlet /> {/* 각 페이지 내용 */}
            </main>
          </div>
        </div>
      </div>

      <ChangePasswordModal
        open={open}
        username={me?.username || ""}
        roleLabel={roleLabelMap[me?.role] || ""}
        force={!!me?.must_change_password}
        onDone={async () => {
          setOpen(false);
          await reload(); // me 갱신
        }}
      />
    </div>
  );
}
